/** Server-side table pagination for Sales/Tech office lists (matches Table page/pageNumber). */
export const OFFICES_DEFAULT_PAGE_SIZE = 50;

export function officesPaginationState(pageSize = OFFICES_DEFAULT_PAGE_SIZE) {
  return {
    page: 1,
    pageNumber: 1,
    limit: pageSize,
    pageSize,
  };
}

export function resolveOfficesFetchParams(pagination: {
  page?: number;
  pageNumber?: number;
  limit?: number;
  pageSize?: number;
}) {
  return {
    page: pagination.pageNumber ?? pagination.page ?? 1,
    limit: pagination.pageSize ?? pagination.limit ?? OFFICES_DEFAULT_PAGE_SIZE,
  };
}
